module.exports = __webpack_public_path__ + "img/mean5.fbf4f01f.png";